import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import QRCode from "qrcode.react";
import NeoinLogo from '../../../Assets/img/Neoin-circle-logo.png'

const QrCodeProfile = ({ qrCodeUrl, size, logo, type }) => {

  return (
    <Link to={qrCodeUrl} target="_blank" rel="noreferrer" className="profile-qr-link-tag">
      <div style={{ position: "relative", width: size, height: size }}>
        <QRCode
          value={qrCodeUrl}
          size={size}
          renderAs={type}
          bgColor="#ffffff"
          fgColor="#000000"
          style={{ position: "absolute", top: 0, left: 0 }}
          imageSettings={
            logo
              ? {
                  src: logo,
                  x: undefined,
                  y: undefined,
                  height: size / 5,
                  width: size / 5,
                  opacity: 1,
                  excavate: true,
                }
              : undefined // If no logo, imageSettings is not set
          }
        />
      </div>
    </Link>
  );
};

QrCodeProfile.propTypes = {
  type: PropTypes.oneOf(["canvas", "svg"]),
  size: PropTypes.number,
};

QrCodeProfile.defaultProps = {
  size: 100,
  type: "svg",
};

export default QrCodeProfile;